import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { ListRow } from 'basic-components';
import { Exit } from 'basic-components/icons';
import { StatusesEnums } from 'dashboard-services/api/statuses';
import { DashboardLinkFactory } from 'ng-common-features/urlBuilder';
import { StatusIcon } from 'primary-components';

import { statusesActions } from 'actions/modules/statuses';
import { routing } from 'routing';

import { When } from 'react-if';

import './StatusRowMobile.scss';

const StatusRowMobile = ({ category, groupName = undefined, jobId, name, scrollContRef, status, version = undefined }) => {
  const dispatch = useDispatch(),
        navigate = useNavigate(),
        goToDetails = useCallback(() => {
          dispatch(statusesActions.changeValue(jobId, "jobId"))
          navigate(DashboardLinkFactory.statuses.details({ baseUrl: "", groupName: category === routing.dataScience.readableName ? groupName : name, jobId, name: category === routing.dataScience.readableName ? name : undefined, type: category }))
        },[category, dispatch, groupName, jobId, name, navigate])

  return (
    <ListRow
        className="statuses-row-mobile"
        height={72}
        scrollContRef={scrollContRef}
    >
      <div className="statuses-row-mobile__icon">
        <StatusIcon
            status={status}
        />
      </div>
        <div className="statuses-row-mobile__description">
          <div className="statuses-row-mobile__description__name">
            {name + (version ? " v." + version : "")}
          </div>
          <div className="statuses-row-mobile__description__group">
            {groupName}
          </div>
          <When condition={status === StatusesEnums.STATUS.PAUSED}>
            {() => (
              <div className="statuses-row-mobile__description__approve">
                This pipeline requiers approval
              </div>
            )}
          </When>
        </div>
      <div 
          className="statuses-row-mobile__link"
          onClick={goToDetails}
      >
        <Exit
            color="blue-bright"
            height={24}
            width={24}
        />
      </div>
    </ListRow>
  )
}

StatusRowMobile.propTypes = {
  category: PropTypes.string.isRequired,
  groupName: PropTypes.string,
  jobId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  scrollContRef: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  version: PropTypes.string
}

export default StatusRowMobile;
